import React from 'react';
import HubScreen from './HubScreen';
import Data from './Data';
import DataQuality from './DataQuality';
import DataCompleteness from './DataCompleteness';
import Duplicates from './Duplicates';
import BulkEditor from './BulkEditor';
import TagNormalizer from './TagNormalizer';
import LocationQuality from './LocationQuality';

const TABS = [
  { id: 'data', label: 'Data Health', Component: Data },
  { id: 'dataquality', label: 'Data Quality', Component: DataQuality },
  { id: 'datacompleteness', label: 'Completeness', Component: DataCompleteness },
  { id: 'duplicates', label: 'Deduplication', Component: Duplicates },
  { id: 'bulkeditor', label: 'Bulk Editor', Component: BulkEditor },
  { id: 'tagnormalizer', label: 'Tag Normalizer', Component: TagNormalizer },
  { id: 'locationquality', label: 'Location Quality', Component: LocationQuality },
];

export default function DataHub(props) {
  return <HubScreen tabs={TABS} hubId="data" passProps={props} />;
}
